export default "__VITE_ASSET__557f26b4__"